// Pixel sprites for the home-screen dock. Same 8x8 map + crispEdges SVG
// system as stamp-icons.tsx / collectible-icons.tsx so the dock matches the
// rest of the app's custom pixel art instead of platform emoji.

const MAPS: Record<string, string[]> = {
  // Satchel: boxy bag with a top handle.
  loot:   ['...##...', '..####..', '.#....#.', '########', '##....##', '##.##.##', '##....##', '########'],
  // Crossed swords: an X with heavier hilt pixels at the base.
  quests: ['#......#', '##....##', '.##..##.', '..####..', '..####..', '.##..##.', '##....##', '#......#'],
  // Lore page: sheet with text lines.
  lore:   ['########', '#......#', '#.####.#', '#......#', '#.####.#', '#......#', '#.##...#', '########'],
  // The gold bean — the app's ONE currency icon. Oval with a wavy centre
  // crease; replaces the straight-diagonal stamp bean (Nik disliked it),
  // the lucide Coffee mug on quest rewards, and the lucide Coins on lore
  // costs. Render it gold (text-yellow-400).
  bean:   ['..####..', '.######.', '.##.###.', '.###.##.', '.###.##.', '.##.###.', '.######.', '..####..'],
};

export const DOCK_ICON_IDS = Object.keys(MAPS);

// Multicolour bean sprite for the header currency pill (Nik's reference
// screenshot 2026-08-06): gold body, black outline, dark wavy crease, olive
// shade. The single-colour DockGlyph 'bean' stays for small inline uses
// (quest rewards, lore costs) where currentColor sizing matters.
const BEAN_ROWS = [
  '...xxxx...',
  '..xggggx..',
  '.xggddggx.',
  '.xgggddgx.',
  'xggggddggx',
  'xggggddggx',
  'xgggddgogx',
  '.xgddggox.',
  '.xgggogox.',
  '..xggogx..',
  '...xxxx...',
];
const BEAN_COLORS: Record<string, string> = {
  x: '#111111', g: '#ffcc00', d: '#6b5300', o: '#c9a227',
};

export function PixelBeanSprite({ className = '' }: { className?: string }) {
  const cells: JSX.Element[] = [];
  BEAN_ROWS.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      const c = row[x];
      if (c !== '.') {
        cells.push(<rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={BEAN_COLORS[c]} />);
      }
    }
  });
  return (
    <svg
      role="img"
      aria-label="beans"
      viewBox="0 0 10 11"
      className={className}
      shapeRendering="crispEdges"
    >
      {cells}
    </svg>
  );
}

export function DockGlyph({ icon, className = '' }: { icon: string; className?: string }) {
  const map = MAPS[icon];
  if (!map) return null;
  const cells: JSX.Element[] = [];
  map.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      if (row[x] === '#') {
        cells.push(<rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} />);
      }
    }
  });
  return (
    <svg
      role="img"
      aria-label={icon}
      viewBox="0 0 8 8"
      className={className}
      fill="currentColor"
      shapeRendering="crispEdges"
    >
      {cells}
    </svg>
  );
}
